export default __webpack_public_path__ + "ec5f78682f28686ac9de5ceb7e16eb68.png";